var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHwHarshBrakingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    className: "hw_icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;}.cls-4{fill:#18303e;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 32,
    height: 32
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Harsh braking (1)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 30,
    y1: 20.6,
    x2: 25.9,
    y2: 20.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 30,
    y1: 23.6,
    x2: 24.5,
    y2: 23.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 30,
    y1: 26.7,
    x2: 21.7,
    y2: 26.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M14.9,26.5A10.7,10.7,0,1,0,2,16a11.1,11.1,0,0,0,3.1,7.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M15.9,2.5a13.8,13.8,0,0,1,9.6,8.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M6.5,12.4l3.6,2.1h0A3,3,0,0,1,12.7,13h0V8.8h0a7.1,7.1,0,0,0-6.2,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M5.5,16a6.7,6.7,0,0,0,1.7,4.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "5.5 16 5.5 16 9.7 16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M9.7,16h0a3,3,0,0,0,1.5,2.6h0l-.8,1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19,19.6l-3.6-2.1h0A3.2,3.2,0,0,1,12.7,19h0v4.2h0A7.2,7.2,0,0,0,19,19.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16.3,9.7l-2,3.7h-.1A2.9,2.9,0,0,1,15.8,16H20a7.3,7.3,0,0,0-3.7-6.3"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 12.7,
    cy: 16,
    r: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M7.2,20.7a6.2,6.2,0,0,1-1.4-2.8A5.8,5.8,0,0,1,5.5,16a7.2,7.2,0,0,1,7.2-7.2,7.2,7.2,0,1,1,0,14.4h-.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8.1,19.4a1,1,0,0,1,1.7,0L13,23.8l2.7,3.9a1.2,1.2,0,0,1-.9,1.8H3.1a1.2,1.2,0,0,1-.9-1.8l2.7-3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M9.5,21.9v2.3c-.1.7-.1,1.5-.2,2.2a.3.3,0,0,1-.3.3q-.3-.1-.3-.3a16.4,16.4,0,0,1-.2-2.2V21.9a.7.7,0,0,1,.5-.4C9.3,21.5,9.4,21.7,9.5,21.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M9,27.3a.5.5,0,0,0-.5.5.5.5,0,0,0,1,0,.5.5,0,0,0-.5-.5Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHwHarshBrakingIcon);
export default __webpack_public_path__ + "static/media/hw_harsh_braking_icon.50aa91da7dc11cee5c43b1eebc983ab9.svg";
export { ForwardRef as ReactComponent };